import { NAVIGATION_PATHS } from "@/const/navigation";
import { isMfaRequiredError } from "@/lib/auth/mfaErrors";
import {
  mfaChallengePathReturningTo,
  mfaSetupPathReturningTo,
} from "@/lib/auth/mfaNavigation";
import { supabaseClient } from "@/lib/supabase/supabaseClient";
import { buildMainDomainUrl } from "@/lib/utils/navigation-utils";

/**
 * The code page when the session has a factor but no code yet (e.g. another
 * tab signed in again), else setup.
 */
export async function toRequiredMfaStep() {
  const { data } =
    await supabaseClient.auth.mfa.getAuthenticatorAssuranceLevel();
  const owesCode = data?.nextLevel === "aal2" && data.currentLevel !== "aal2";

  const mainOrigin = new URL(buildMainDomainUrl("/")).origin;
  if (window.location.origin !== mainOrigin) {
    // Cross-origin from a subdomain, which `router` silently drops. A subdomain
    // path means nothing on the main domain, so it isn't kept.
    window.location.href = buildMainDomainUrl(
      owesCode ? NAVIGATION_PATHS.Mfa : NAVIGATION_PATHS.MfaSetup
    );
    return;
  }

  const here = `${window.location.pathname}${window.location.search}`;
  window.location.href = owesCode
    ? mfaChallengePathReturningTo(here)
    : mfaSetupPathReturningTo(here);
}

export function redirectIfMfaRequired(error: unknown): boolean {
  if (typeof window === "undefined" || !isMfaRequiredError(error)) return false;
  if (window.location.pathname.startsWith("/auth/")) return false;
  void toRequiredMfaStep();
  return true;
}
